import OrganizationTicketsPerService from "../../../components/organization/reports/daily/OrganizationTicketsPerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { TICKETS_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationTicketsPerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_tickets_per_service}
    title="Tickets Per Service"
    helmetTitle="Daily Organization Tickets Per Service"
    descriptionKey="TicketsPerService"
    columnDefinitions={TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationTicketsPerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationTicketsPerService;
